module.exports = __webpack_public_path__ + "media/35_BL.d89ae853.mp3";